import CustomDateTimePicker from "../../../sharedComponents/datetimePicker/CustomDateTimePicker";
import FormWrapper from "../FormWrapper/FormWrapper";
import "./ParcelForm.css";
import Box from "../../../../assets/Icons/box.png";
import Bundle from "../../../../assets/Icons/bundle.png";
import Email from "../../../../assets/Icons/email.png";
import Package from "../../../../assets/Icons/package.png";
import { useState, useEffect } from "react";
import { IoIosWarning } from "react-icons/io";
import Modal from "../Modal/Modal";
import { IoClose } from "react-icons/io5";
import { toast } from "react-toastify";
import DropDown from "../../Shared_components/DropDown";
import TextArea from "../../Shared_components/TextArea";
import InputField from "../../Shared_components/InputField";
import IncrementTextbox from "../../../sharedComponents/IncrementTextBox/IncrementTextBox";
import { MenuItem, TextField, Typography } from "@mui/material";
import { formatCurrency } from "../../../../utils/formatCurrency";
import { resolveWalkInWeightRate } from "../../../../utils/adminWalkInBooking";
const ParcelForm = ({
  productType,
  numberOfItems,
  parcelContent,
  shipmentTime,
  itemDescription,
  productValue,
  packaging,
  producDetails,
  fragileItems,
  preset,
  additionalInfo,
  productWeight,
  productLength,
  productWidth,
  productHeight,
  updateFields,
  fetchedFormData,
  productGroup,
  fruitsWeights = [],
  dimensions = [],
  presets = [],
  route, // Selected route ID
  mangoNoteOnly = false,
  showWeightRate = false,
  weightBands = [],
}) => {
  const { ProductType, Prohibiteditem, itemType } = fetchedFormData;

  // Pricing draft from sessionStorage (quotation flow) or localStorage
  const pricingDraftRaw =
    sessionStorage.getItem("sundorbonPricingDraft") ||
    localStorage.getItem("sundorbonPricingDraft");
  const hasPricingDraft = !!pricingDraftRaw;
  let pricingData = {};
  try {
    pricingData = JSON.parse(pricingDraftRaw || "{}");
  } catch {
    pricingData = {};
  }
  const isMangoPricing = pricingData?.pricingType === "mango";
  const isRegularPricing = pricingData?.pricingType === "regular";
  const excludeFruitsAndMango =
    !isMangoPricing && (isRegularPricing || !hasPricingDraft);
  
  // Filter presets by selected route and category (per item)
  // If Fruits category (19) is selected for an item, show only fruit-related presets
  // Otherwise, show non-fruit presets filtered by route
  const getFilteredPresets = (itemCategory) => {
    if (!presets || presets.length === 0) return [];
    
    // Check if current item is Fruits category
    const isFruitsCategory = itemCategory === 19 || parseInt(itemCategory) === 19;
    
    let filtered = presets;
    
    // Filter by category: if Fruits, show only fruit boxes; otherwise exclude fruit boxes
    if (isFruitsCategory) {
      // Show only presets with "fruit" in the name (case-insensitive)
      filtered = filtered.filter(p => {
        const name = (p.name || p.dimensionName || "").toLowerCase();
        return name.includes("fruit");
      });
    } else {
      // Exclude fruit boxes for non-fruit categories
      filtered = filtered.filter(p => {
        const name = (p.name || p.dimensionName || "").toLowerCase();
        return !name.includes("fruit");
      });
    }
    
    // Then filter by route if route is selected
    if (route && filtered.length > 0) {
      filtered = filtered.filter(p => p.routeId === parseInt(route) || !p.routeId);
    }
    
    return filtered;
  };

  const [initialObj, setInitialOBJ] = useState(producDetails);
  
  // Initialize per-item dimension and weight fields if they don't exist
  useEffect(() => {
    setInitialOBJ((prev) => {
      const updated = prev.map((item, idx) => {
        const needsInit = item.itemLength === undefined && item.itemWidth === undefined && item.itemHeight === undefined && item.itemWeight === undefined && item.itemPackaging === undefined;
        if (needsInit) {
          // Initialize with global values for first item, empty/default for others
          return {
            ...item,
            itemLength: idx === 0 ? productLength || "" : "",
            itemWidth: idx === 0 ? productWidth || "" : "",
            itemHeight: idx === 0 ? productHeight || "" : "",
            itemWeight: idx === 0 ? productWeight || "" : "",
            itemPackaging: idx === 0 ? packaging || "No" : "No",
            deliveryPlanId: idx === 0 ? pricingData?.deliveryPlanId || "" : "",
          };
        }
        // Ensure itemPackaging exists even if other fields are already set
        if (item.itemPackaging === undefined) {
          return {
            ...item,
            itemPackaging: idx === 0 ? packaging || "No" : "No",
          };
        }
        return item;
      });
      return updated;
    });
  }, []); // Only run once on mount

  // Auto-set Fruits/Mango defaults when pricingType is "mango"
  useEffect(() => {
    if (isMangoPricing) {
      setInitialOBJ((prev) => {
        const updated = prev.map((item) => ({
          ...item,
          productGroup: 19,
          productGroupName: ProductType?.find((p) => p.id === 19)?.name || "Fruits",
          productType: 18,
          productTypeName: itemType?.find((t) => t.id === 18)?.name || "Mango",
          itemDescription: "mango",
          productValue: "0",
          itemPackaging: "No",
          productQty: item.productQty && parseInt(item.productQty) >= 3 ? item.productQty : 3,
        }));
        updateFields({ producDetails: updated });
        return updated;
      });
    }
  }, [isMangoPricing]); // eslint-disable-line react-hooks/exhaustive-deps

  // Clear Fruits/Mango selections when pricing draft is absent
  useEffect(() => {
    if (hasPricingDraft) return;
    setInitialOBJ((prev) => {
      const needsClear = prev.some(
        (item) =>
          item.productGroup === 19 ||
          parseInt(item.productGroup, 10) === 19 ||
          item.productType === 18 ||
          parseInt(item.productType, 10) === 18
      );
      if (!needsClear) return prev;
      const updated = prev.map((item) => {
        const isFruit =
          item.productGroup === 19 || parseInt(item.productGroup, 10) === 19;
        const isMango =
          item.productType === 18 || parseInt(item.productType, 10) === 18;
        if (!isFruit && !isMango) return item;
        return {
          ...item,
          ...(isFruit
            ? {
                productGroup: "",
                productGroupName: "",
                productType: "",
                productTypeName: "",
                itemDescription: "",
              }
            : {}),
          ...(isMango && !isFruit
            ? { productType: "", productTypeName: "" }
            : {}),
        };
      });
      updateFields({ producDetails: updated });
      return updated;
    });
  }, [hasPricingDraft]); // eslint-disable-line react-hooks/exhaustive-deps

  // Check if first item is Fruits category (19) – used as a global flag
  const isFruitsCategory = producDetails?.[0]?.productGroup === 19 || parseInt(producDetails?.[0]?.productGroup) === 19;
  
  // Handler for fruit weight selection
  const handleFruitWeightChange = (index, e) => {
    const weightId = parseInt(e.target.value);
    // Use filtered weights first, fallback to all weights
    const filteredWeights = getFilteredFruitsWeights();
    const selectedWeight = filteredWeights.find(w => w.id === weightId) || fruitsWeights.find(w => w.id === weightId);
    if (selectedWeight && selectedWeight.dimensionId) {
      const dimension = dimensions.find(d => d.id === selectedWeight.dimensionId);
      if (dimension) {
        // Update per-item fields
        handleUpdateField(index, "itemWeight", selectedWeight.minimumWeight ? String(selectedWeight.minimumWeight) : "");
        handleUpdateField(index, "itemLength", dimension.length ? String(dimension.length) : "");
        handleUpdateField(index, "itemWidth", dimension.width ? String(dimension.width) : "");
        handleUpdateField(index, "itemHeight", dimension.height ? String(dimension.height) : "");
        // Also update global fields for backward compatibility (first item only)
        if (index === 0) {
          updateFields({
            productWeight: selectedWeight.minimumWeight ? String(selectedWeight.minimumWeight) : "",
            productLength: dimension.length ? String(dimension.length) : "",
            productWidth: dimension.width ? String(dimension.width) : "",
            productHeight: dimension.height ? String(dimension.height) : "",
            preset: "", // Clear preset when using fruit weights
          });
        }
      }
    }
  };
  
  // Filter fruits weights by selected route
  const getFilteredFruitsWeights = () => {
    if (!fruitsWeights || fruitsWeights.length === 0) return [];
    
    // Filter by route if route is selected
    if (route) {
      return fruitsWeights.filter(w => w.routeId === parseInt(route));
    }
    
    // If no route selected, return all fruit weights
    return fruitsWeights;
  };

  // Get current selected weight ID if any (for fruits dropdown)
  const getCurrentWeightId = (index, isItemFruit) => {
    if (!isItemFruit) return "";
    const itemWeight = initialObj[index]?.itemWeight || (index === 0 ? productWeight : "");
    if (!itemWeight) return "";
    
    // Use filtered weights for matching
    const filteredWeights = getFilteredFruitsWeights();
    const weight = filteredWeights.find(w => 
      parseFloat(w.minimumWeight) === parseFloat(itemWeight) ||
      (parseFloat(itemWeight) >= parseFloat(w.minimumWeight) && 
       parseFloat(itemWeight) <= parseFloat(w.maximumWeight))
    );
    return weight ? weight.id : "";
  };

  const handleDateTimeChange = (newValue) => {
    updateFields({ shipmentTime: newValue });
  };


  const [selectedPreset, setSelectedPreset] = useState("");

  // Helper function to get icon for preset based on name
  // Returns different icons for different preset types
  const getPresetIcon = (presetName) => {
    const name = presetName?.toLowerCase() || "";
    
    // Envelope presets
    if (name.includes("envelope") || name.includes("a4")) return Email;
    
    // Fruit boxes - use Box icon
    if (name.includes("fruit")) return Box;
    
    // Moving boxes - use Box icon
    if (name.includes("moving") && name.includes("box")) return Box;
    
    // Bundle presets
    if (name.includes("bundle")) return Bundle;
    
    // Size-based boxes (Small, Medium, Large, Extra Large) - use Package icon
    if (name.includes("small") || name.includes("medium") || name.includes("large") || name.includes("extra")) {
      return Package;
    }
    
    // Generic box - use Box icon
    if (name.includes("box")) return Box;
    
    // Default - use Package icon
    return Package;
  };

  const handleSelect = (index, presetObj) => {
    // presetObj can be either a preset object from API or a string (for backward compatibility)
    let presetData;
    
    if (typeof presetObj === "string") {
      // Backward compatibility: if string is passed, try to find preset by name
      presetData = presets.find(p => p.name === presetObj || p.presetName === presetObj);
      if (!presetData) {
        // Fallback to hardcoded presets for backward compatibility
        if (presetObj === "A4 Envelope") {
          presetData = { name: "A4 Envelope", length: 12, width: 9, height: 1, weight: 1 };
        } else if (presetObj === "Moving Box") {
          presetData = { name: "Moving Box", length: 30, width: 18, height: 18, weight: 5 };
        }
      }
    } else {
      presetData = presetObj;
    }

    if (!presetData) return;

    const presetName = presetData.name || presetData.dimensionName || presetData.presetName || presetObj;
    setSelectedPreset(presetName);

    // Extract dimensions and weight from preset data
    // Support multiple possible property names from API
    const length = presetData.length || presetData.itemLength || presetData.productLength || "";
    const width = presetData.width || presetData.itemWidth || presetData.productWidth || "";
    const height = presetData.height || presetData.itemHeight || presetData.productHeight || "";
    // Weight may not be available in Dimension API, so we'll leave it empty or use a default
    const weight = presetData.weight || presetData.itemWeight || presetData.productWeight || "";

    // Update per-item fields
    if (length) handleUpdateField(index, "itemLength", String(length));
    if (width) handleUpdateField(index, "itemWidth", String(width));
    if (height) handleUpdateField(index, "itemHeight", String(height));
    // Only update weight if it's provided (Dimension API may not have weight)
    if (weight) handleUpdateField(index, "itemWeight", String(weight));

    // Also update global fields for backward compatibility (first item only)
    if (index === 0) {
      updateFields({
        preset: presetName,
        productLength: length ? String(length) : productLength,
        productWidth: width ? String(width) : productWidth,
        productHeight: height ? String(height) : productHeight,
        // Only update weight if provided
        ...(weight && { productWeight: String(weight) }),
      });
    }
  };

  // weight input handle.
  const weightInputHandle = (e) => {
    const weight = parseInt(e.target.value);

    // if(weight>5 || e.target.value==="")  updateFields({ productWeight: ""});

    if (weight > 999 || e.target.value === "") {
      updateFields({
        preset: "",
        productHeight: "",
        productWidth: "",
        productLength: "",
        productWeight: "",
      });
    }

    if (weight <= 1) {
      updateFields({
        preset: "A4 Envelope",
        productHeight: "1",
        productWidth: "9",
        productLength: "12",
        productWeight: e.target.value,
      });
    } else if (weight <= 999 && weight > 1) {
      updateFields({
        preset: "Moving Box",
        productHeight: "18",
        productWidth: "18",
        productLength: "30",
        productWeight: e.target.value,
      });
    }
  };
  const [isModalOpen, setModalOpen] = useState(false);

  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  // weight input field validation.

  const weightFieldValidation = (e) => {
    let inputField = e.target;
    const inputFieldValue = parseFloat(inputField.value);
    if (0 >= inputFieldValue) {
      inputField.value = "1";
      updateFields({ productWeight: inputField.value });
      toast.error("Weight Should be more than 0 !");
    }
  };

  const [value, setValue] = useState(1);

  const handleChange = (e) => {
    const newValue = parseInt(e.target.value, 10);
    if (newValue >= 1 && newValue <= 10) {
      setValue(newValue);
    }
  };

  const [productQty, setProductQty] = useState("");

  // Handler for input change
  const itemInputHandle = (e) => {
    setProductQty(e.target.value);
  };

  // Validation function for item qty field
  const itemQtyFieldValidation = () => {
    // Implement validation logic for Item Qty
  };
  const addAnotherItem = () => {
    setInitialOBJ([
      ...initialObj,
      {
        productGroup: "",
        productType: "",
        itemDescription: "",
        productValue: "",
        productQty: 0,
        itemLength: "",
        itemWidth: "",
        itemHeight: "",
        itemWeight: "",
        itemPackaging: "No",
        deliveryPlanId: "",
        deliveryPlanChoiceRequired: false,
      },
    ]);
  };
  // const handleUpdateField = (index, field, value) => {
  //   setInitialOBJ((prevState) => {
  //     const updatedState = [...prevState];
  //     updatedState[index][field] = value;
  //     return updatedState;
  //   });
  //   updateFields({ producDetails: initialObj });
  // };
  const handleUpdateField = (index, field, value) => {
    setInitialOBJ((prevState) => {
      const updatedState = [...prevState];

      // If updating productGroup or productType, store both ID and name
      if (field === "productGroup") {
        const numericVal = parseInt(value);
        const selectedProduct = ProductType?.find((p) => p.id === numericVal);
        updatedState[index][field] = value;
        updatedState[index]["productGroupName"] = selectedProduct?.name || "";
        updatedState[index]["deliveryPlanId"] = "";
        updatedState[index]["deliveryPlanChoiceRequired"] = false;

        // Auto-select Mango when Fruits category (19) is chosen
        if (numericVal === 19) {
          const mangoType = itemType?.find((t) => t.id === 18);
          if (mangoType) {
            updatedState[index]["productType"] = 18;
            updatedState[index]["productTypeName"] = mangoType.name;
            if (isMangoPricing) {
              updatedState[index]["itemDescription"] = "mango";
              updatedState[index]["productValue"] = "0";
              updatedState[index]["itemPackaging"] = "No";
              updatedState[index]["productQty"] = 3;
            }
          }
          
          // Clear dimension data when Fruits category is selected
          updatedState[index]["itemLength"] = "";
          updatedState[index]["itemWidth"] = "";
          updatedState[index]["itemHeight"] = "";
          updatedState[index]["itemWeight"] = "";
          
          // Also clear global fields for first item
          if (index === 0) {
            updateFields({
              productLength: "",
              productWidth: "",
              productHeight: "",
              productWeight: "",
              preset: "",
            });
          }
        }
      } else if (field === "productType") {
        const selectedItemType = itemType?.find(
          (i) => i.id === parseInt(value)
        );
        updatedState[index][field] = value;
        updatedState[index]["productTypeName"] = selectedItemType?.name || "";
      } else {
        updatedState[index][field] = value;
      }

      // Sync up to parent form state
      updateFields({ producDetails: updatedState });
      return updatedState;
    });
  };
  
  const handleRemoveItem = (index) => {
    setInitialOBJ((prev) => prev.filter((_, i) => i !== index));
    updateFields({ producDetails: initialObj });
  };


  // const textFieldStyle = {
  //   backgroundColor: "white",
  //   borderRadius: "8px",
  //   width: "100%",
  //   '& .MuiOutlinedInput-root': {
  //     '& fieldset': {
  //       borderColor: "#ccc",
  //       borderRadius: "12px"
  //     },
  //     '&:hover fieldset': {
  //       borderColor: "#1976d2",
  //     },
  //     '&.Mui-focused fieldset': {
  //       borderColor: "#1976d2",
  //     },
  //   },
  // };

  const textFieldStyle = {
    backgroundColor: "hsl(var(--form-input-bg))",
    borderRadius: "12px",
    width: "100%",
    // hide floating label, we are using text above boxes instead
    "& .MuiInputLabel-root": { display: "none" },
    "& input::placeholder": {
      color: "hsl(var(--form-placeholder))", // Original placeholder color
      opacity: 1,
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "hsl(var(--form-input-border))",
        borderRadius: "12px",
      },
      "&:hover fieldset": {
        borderColor: "hsl(var(--form-input-border-focus))",
      },
      "&.Mui-focused fieldset": {
        borderColor: "hsl(var(--form-input-border-focus))",
      },
    },
  };

  if (mangoNoteOnly) {
    return (
      <FormWrapper title="Parcel Details">
        <Typography
          variant="h5"
          className="text-center"
          sx={{
            fontWeight: 700,
            marginBottom: "8px",
            color: "hsl(var(--foreground))",
            textAlign: "center",
          }}
        >
          Parcel Information Form
        </Typography>
        <Typography
          variant="body2"
          className="text-center"
          sx={{ color: "hsl(var(--muted-foreground))", marginBottom: "16px" }}
        >
          Your mango box and quantity are already set from your quotation. Please
          add a note below.
        </Typography>
        <div className="mt-3 mb-10">
          <TextField
            sx={textFieldStyle}
            fullWidth
            multiline
            rows={4}
            required
            id="mango-parcel-note"
            label="Note"
            variant="outlined"
            value={additionalInfo}
            onChange={(e) =>
              updateFields({ additionalInfo: e.target.value })
            }
          />
        </div>
      </FormWrapper>
    );
  }

  return (
    <>
      <div>
        <Modal show={isModalOpen} onClose={handleCloseModal}>
          <div className="w-full flex justify-end">
            <button
              onClick={handleCloseModal}
              className="text-right"
              title="close"
            >
              <IoClose className="text-2xl" />
            </button>
          </div>
          <div>
            <div className="text-2xl font-semibold mb-3">
              Prohibited Items list
            </div>
            {Prohibiteditem?.map((item) => (
              <div key={item.id} className="my-1">
                {item.id}. {item.itemName}
              </div>
            ))}
          </div>
        </Modal>
      </div>

      <FormWrapper title="Parcel Details">

      <Typography
        variant="h5"
        className="text-center"
        sx={{
          fontWeight: 700,
          marginBottom: "8px",
          color: "hsl(var(--foreground))",
          textAlign: "center",
        }}
      >
        Parcel Information Form
      </Typography>
      <Typography
        variant="body2"
        className="text-center"
        sx={{ color: "hsl(var(--muted-foreground))", marginBottom: "16px" }}
      >
        Please fill in your parcel information below.
      </Typography>
        {/* **********  ItemDetails Start **************  */}
        {initialObj.map((item, index) => {
          return (
            // <div key={index}>
            //   <div className="flex justify-between items-center font-semibold text-xl mt-4">
            //     <div>{initialObj.length > 1 && `Item ${index + 1}`}</div>
            //     {initialObj.length > 1 && (
            //       <div
            //         className="text-red-500 cursor-pointer"
            //         onClick={() => handleRemoveItem(index)}
            //       >
            //         Remove
            //       </div>
            //     )}
            //   </div>
  //           <div key={index}>
  // <div className="flex justify-between items-center font-semibold text-xl mt-4">
  //   <div className="text-blue-600">
  //     {initialObj.length > 1 && `Item ${index + 1}`}
  //   </div>
  //   {initialObj.length > 1 && (
  //     <div
  //       className="text-red-500 cursor-pointer"
  //       onClick={() => handleRemoveItem(index)}
  //     >
  //       Remove
  //     </div>
  //   )}
  // </div>
  <div key={index}>
  <div className="flex justify-between items-center font-semibold text-xl mt-4">
    <div className="text-blue-600">
      {initialObj.length > 1 && `Item ${index + 1}`}
    </div>
    {initialObj.length > 1 && (
      <div
        className="w-8 h-8 flex justify-center items-center bg-red-500 text-white rounded cursor-pointer hover:bg-red-600"
        onClick={() => handleRemoveItem(index)}
      >
        ✕
      </div>
    )}
  </div>



  <div className="flex w-full gap-x-8 sender-form-container">
  {/* Select Item Group (Left Side) */}
  <div className="flex flex-col justify-center w-full space-y-2">
    <div className="booking-form-label text-sm">Item Group</div>
    {/* <TextField
      sx={textFieldStyle}
      select
      required
      id="item-group"
      label="Select item group"
      variant="outlined"
      value={item.productGroup}
      onChange={(e) => handleUpdateField(index, "productGroup", e.target.value)}
    >
      {ProductType?.map((product) => (
        <MenuItem key={product.id} value={product.id}>
          {product.name}
        </MenuItem>
      ))}
    </TextField> */}
          {/* Product Group Dropdown */}
          <TextField
        sx={textFieldStyle}
        select
        required
        disabled={isMangoPricing}
        id="item-group"
        placeholder="Select item group"
        variant="outlined"
        value={item.productGroup}
        onChange={(e) => handleUpdateField(index, "productGroup", e.target.value)}
      >
        {ProductType?.filter(
          (product) => !(excludeFruitsAndMango && product.id === 19)
        ).map((product) => (
          <MenuItem key={product.id} value={product.id}>
            {product.name}
          </MenuItem>
        ))}
      </TextField>

    <button
      type="button"
      onClick={handleOpenModal}
      className="prohibited-btn self-start items-center mt-3 text-[1rem] underline font-semibold flex"
    >
      <IoIosWarning className="mr-1" /> Prohibited item list
    </button>
  </div>

  {/* Select Item Type (Right Side) */}
  <div style={{marginBottom:"2rem"}}className="flex flex-col justify-center w-full space-y-2">
    <div className="booking-form-label text-sm">Item Type</div>
    {/* <TextField
      sx={textFieldStyle}
      select
      required
      id="item-type"
      label="Select item type"
      variant="outlined"
      value={item.productType}
      onChange={(e) => handleUpdateField(index, "productType", e.target.value)}
    >
      {itemType?.map((type) => (
        <MenuItem key={type.id} value={type.id}>
          {type.name}
        </MenuItem>
      ))}
    </TextField> */}
          {/* Item Type Dropdown */}
          <TextField
        sx={textFieldStyle}
        select
        required
        disabled={isMangoPricing}
        id="item-type"
        placeholder="Select item type"
        variant="outlined"
        value={item.productType}
        onChange={(e) => handleUpdateField(index, "productType", e.target.value)}
      >
        {itemType?.filter(
          (type) => !(excludeFruitsAndMango && type.id === 18)
        ).map((type) => (
          <MenuItem key={type.id} value={type.id}>
            {type.name}
          </MenuItem>
        ))}
      </TextField>
  </div>
</div>
              <div className="flex flex-col md:flex-row w-full gap-6">
                {/* Hide Unique Item Description for Mango pricing */}
                {!isMangoPricing && (
                <div className="w-full space-y-2">
                  <div className="booking-form-label text-sm">Unique Item Description</div>
                  <TextField
                    sx={textFieldStyle}
                    required
                    type="text"
                    id="unique-item-description"
                    placeholder="Describe the item"
                    variant="outlined"
                    value={item.itemDescription}
                    onChange={(e) => handleUpdateField(index, "itemDescription", e.target.value)}
                  />
                </div>
                )}

                {/* Hide Product Value for Mango pricing */}
                {!isMangoPricing && (
                <div className="w-full space-y-2">
                  <div className="booking-form-label text-sm">Product Value</div>
                  <TextField
                    sx={textFieldStyle}
                    required
                    type="number"
                    id="product-value"
                    placeholder="Product value"
                    variant="outlined"
                    value={item.productValue}
                    onChange={(e) => handleUpdateField(index, "productValue", e.target.value)}
                  />
                </div>
                )}

                <div className="w-full space-y-2">
                  <div className="booking-form-label text-sm">
                    {(item.productGroup === 19 || parseInt(item.productGroup) === 19) 
                      ? "Box Quantity" 
                      : "Item Quantity"}
                  </div>
                  <TextField
                    sx={textFieldStyle}
                    required
                    type="number"
                    id="item-qty"
                    placeholder="Qty"
                    variant="outlined"
                    value={item.productQty}
                    onChange={(e) => {
                      const val = parseInt(e.target.value);
                      if (isMangoPricing && val < 3) return;
                      handleUpdateField(index, "productQty", e.target.value);
                    }}
                    inputProps={{
                      min: isMangoPricing ? 3 : 0,
                      step: 1,
                    }}
                  />
                </div>
              </div>

              {/* Extra Packaging per item */}
              <div className="radio-container mt-4 flex-col md:flex-row flex w-full sender-form-container ">
                <div className="w-full  border-0 outline-none  flex items-center">
                  <div className="mr-5">Extra Packaging: </div>
                  <div className="mr-4">
                    <input
                      type="radio"
                      id={`package1-${index}`}
                      name={`package-${index}`}
                      value="Yes"
                      onChange={(e) => handleUpdateField(index, "itemPackaging", e.target.value)}
                      checked={isMangoPricing ? false : (item.itemPackaging !== undefined ? item.itemPackaging : (index === 0 ? packaging : "No")) === "Yes"}
                      disabled={isMangoPricing}
                      required
                    />
                    <label htmlFor={`package1-${index}`} className={`ml-2 ${isMangoPricing ? "opacity-50" : ""}`}>
                      Yes
                    </label>
                  </div>
                  <div className="ml-4 flex items-center">
                    <input
                      type="radio"
                      id={`package2-${index}`}
                      name={`package-${index}`}
                      value="No"
                      onChange={(e) => handleUpdateField(index, "itemPackaging", e.target.value)}
                      checked={isMangoPricing ? true : (item.itemPackaging !== undefined ? item.itemPackaging : (index === 0 ? packaging : "No")) === "No"}
                      disabled={isMangoPricing}
                      required
                    />
                    <label htmlFor={`package2-${index}`} className={`ml-2 ${isMangoPricing ? "opacity-50" : ""}`}>
                      No
                    </label>
                  </div>
                </div>
              </div>

              {/* Presets per item - Dynamic */}
              {/* Hide presets when Fruits category (19) is selected */}
              {(() => {
                const isItemFruit = item.productGroup === 19 || parseInt(item.productGroup) === 19;
                
                // Hide presets for Fruits category
                if (isItemFruit) {
                  return null;
                }
                
                // Get filtered presets for this specific item's category
                const itemFilteredPresets = getFilteredPresets(item.productGroup);
                
                return (
                  <div className="mt-3">
                    <div className="font-semibold text-xl mb-4">Presets</div>

                    <div className="flex flex-wrap lg:gap-7 gap-3">
                      {itemFilteredPresets && itemFilteredPresets.length > 0 ? (
                        // Render presets from Dimension API (filtered by category and route)
                        itemFilteredPresets.map((presetItem) => {
                      // Use name (which has underscores replaced) for display, or fallback to dimensionName
                      const presetName = presetItem.name || presetItem.dimensionName || "";
                      const presetLength = presetItem.length || "-";
                      const presetWidth = presetItem.width || "-";
                      const presetHeight = presetItem.height || "-";
                      const presetIcon = presetItem.icon || getPresetIcon(presetName);
                      // Check if selected by comparing with name or dimensionName
                      const isSelected = preset === presetName || preset === presetItem.dimensionName;

                      return (
                        <label
                          key={presetItem.id || presetName}
                          className={`preset-container flex flex-col lg:flex-row w-1/2 lg:w-auto lg:justify-center items-center gap-3 p-3 rounded-lg cursor-pointer border-2 ${
                            isSelected ? "selected" : "border-transparent"
                          }`}
                          onClick={() => handleSelect(index, presetItem)}
                        >
                          <input
                            type="radio"
                            name={`preset-${index}`}
                            value={presetName}
                            className="hidden"
                            checked={isSelected}
                            readOnly
                          />
                          <div className="h-12 w-12 overflow-hidden flex items-center justify-center">
                            {typeof presetIcon === "string" ? (
                              <img src={presetIcon} alt={presetName} className="h-full w-full object-contain" />
                            ) : (
                              <img src={presetIcon} alt={presetName} className="h-full w-full object-contain" />
                            )}
                          </div>
                          <div>
                            <div className="font-semibold">{presetName}</div>
                            <div className="font-semibold">
                              {presetLength !== "-" && presetWidth !== "-" && presetHeight !== "-"
                                ? `${parseFloat(presetLength).toFixed(0)} X ${parseFloat(presetWidth).toFixed(0)} X ${parseFloat(presetHeight).toFixed(0)} in`
                                : "- X - X - in"}
                            </div>
                          </div>
                        </label>
                      );
                    })
                  ) : (
                    // Fallback: Render default hardcoded presets if API returns empty
                    <>
                      <label
                        className={`preset-container flex flex-col lg:flex-row w-1/2 lg:w-auto lg:justify-center items-center gap-3 p-3 rounded-lg cursor-pointer border-2 ${
                          preset === "A4 Envelope" ? "selected" : "border-transparent"
                        }`}
                        onClick={() => handleSelect(index, "A4 Envelope")}
                      >
                        <input
                          type="radio"
                          name={`preset-${index}`}
                          value="A4 Envelope"
                          className="hidden"
                          checked={preset === "A4 Envelope"}
                          readOnly
                        />
                        <div className="h-12 overflow-hidden">
                          <img src={Email} alt="mail" className="h-full" />
                        </div>
                        <div>
                          <div className="font-semibold">A4 Envelope</div>
                          <div className="font-semibold">12 X 9 X 1 in</div>
                        </div>
                      </label>

                      <label
                        className={`preset-container flex lg:flex-row w-1/2 lg:w-auto lg:justify-center flex-col items-center gap-3 p-3 rounded-lg cursor-pointer border-2 ${
                          preset === "Moving Box" ? "selected" : "border-transparent"
                        }`}
                        onClick={() => handleSelect(index, "Moving Box")}
                      >
                        <input
                          type="radio"
                          name={`preset-${index}`}
                          value="Moving Box"
                          className="hidden"
                          checked={preset === "Moving Box"}
                          readOnly
                        />
                        <div className="w-12 h-12">
                          <img src={Box} alt="Box" className="w-full" />
                        </div>
                        <div>
                          <div className="font-semibold">Moving Box</div>
                          <div className="font-semibold">30 X 18 X 18 in</div>
                        </div>
                      </label>
                     </>
                       )}
                     </div>
                   </div>
                 );
               })()}

              {/* Weight Dropdown for Fruits Category */}
              {(() => {
                const isItemFruit = item.productGroup === 19 || parseInt(item.productGroup) === 19;
                
                // Show weight dropdown for Fruits category
                if (isItemFruit) {
                  const filteredFruitsWeights = getFilteredFruitsWeights();
                  return (
                    <div className="w-full mt-3">
                      <div className="text-xl font-semibold mb-3">Select Weight Box *</div>
                      {filteredFruitsWeights.length > 0 ? (
                        <div className="w-full md:w-96">
                          <TextField
                            sx={textFieldStyle}
                            select
                            required
                            id={`fruit-weight-${index}`}
                            label=""
                            variant="outlined"
                            value={getCurrentWeightId(index, isItemFruit)}
                            onChange={(e) => handleFruitWeightChange(index, e)}
                            className="w-full"
                            displayEmpty
                            placeholder="Select Weight Box"
                          >
                            <MenuItem value="" disabled>
                              Select Weight Box
                            </MenuItem>
                            {filteredFruitsWeights.map((weight) => {
                              // Get dimension name from weight object first, then fallback to dimensions array
                              const dimName =
                                weight.dimensionName ||
                                weight.DimensionName ||
                                (dimensions.find((d) => d.id === weight.dimensionId)
                                  ?.dimensionName ||
                                  dimensions.find((d) => d.id === weight.dimensionId)
                                    ?.DimensionName ||
                                  "");
                              const weightRange = `${parseFloat(
                                weight.minimumWeight || 0
                              ).toFixed(2)} - ${parseFloat(
                                weight.maximumWeight || 0
                              ).toFixed(2)} kg`;

                              // Show dimension name with weight range on the right
                              const unit = parseFloat(weight.cost ?? weight.Cost);
                              const rateLabel =
                                showWeightRate && Number.isFinite(unit) && unit > 0
                                  ? ` — ${formatCurrency(unit)}/kg`
                                  : "";
                              const displayLabel = dimName
                                ? `${dimName} (${weightRange})${rateLabel}`
                                : `${weightRange}${rateLabel}`;

                              return (
                                <MenuItem key={weight.id} value={weight.id}>
                                  {displayLabel}
                                </MenuItem>
                              );
                            })}
                          </TextField>
                          {showWeightRate
                            ? (() => {
                                const selectedId = getCurrentWeightId(index, isItemFruit);
                                const selected = filteredFruitsWeights.find(
                                  (w) => String(w.id) === String(selectedId),
                                );
                                const unit = parseFloat(selected?.cost ?? selected?.Cost);
                                if (!(Number.isFinite(unit) && unit > 0)) return null;
                                const kg = parseFloat(
                                  item.itemWeight || selected?.maximumWeight || 0,
                                );
                                const charge =
                                  Number.isFinite(kg) && kg > 0
                                    ? Number((kg * unit).toFixed(2))
                                    : null;
                                return (
                                  <p className="text-xs font-semibold text-stone-700 mt-2">
                                    {formatCurrency(unit)}/kg
                                    {charge != null
                                      ? ` · ${kg}kg × rate = ${formatCurrency(charge)}`
                                      : ""}
                                  </p>
                                );
                              })()
                            : null}
                        </div>
                      ) : (
                        <div className="w-full md:w-96 p-4 border border-red-300 rounded-xl bg-red-50">
                          <div className="text-red-500 text-sm">No weights available for selected route</div>
                        </div>
                      )}
                      
                      {/* Show dimensions as read-only for Fruits category */}
                      <div className="w-full mt-4">
                        <div className="text-xl font-semibold mb-3">Dimensions</div>
                        <div className="flex flex-nowrap justify-start items-center gap-2 overflow-x-auto">
                          <div className="input-border rounded-xl w-20 text-sm text-center">
                            <div>Length</div>
                            <div className="text-xl font-semibold bg-white">
                              {item.itemLength || productLength || "0"}
                            </div>
                          </div>
                          <div className="font-semibold text-center">X</div>
                          <div className="input-border rounded-xl w-20 text-sm text-center">
                            <div>Width</div>
                            <div className="text-xl font-semibold bg-white">
                              {item.itemWidth || productWidth || "0"}
                            </div>
                          </div>
                          <div className="font-semibold text-center">X</div>
                          <div className="input-border rounded-xl w-20 text-sm text-center">
                            <div>Height</div>
                            <div className="text-xl font-semibold bg-white">
                              {item.itemHeight || productHeight || "0"}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                }
                
                // Return null for non-Fruits category - weight dropdown is shown in dimensions section
                return null;
              })()}

              {/* Dimensions + Weight (shown under each item) - Only for non-Fruits categories */}
              {(() => {
                const isItemFruit = item.productGroup === 19 || parseInt(item.productGroup) === 19;
                
                // Hide weight textbox and dimensions section for Fruits category
                if (isItemFruit) {
                  return null;
                }
                
                return (
                  <div className="dimension-wrapper flex flex-col-reverse gap-3 items-center w-full mt-3">
                    <div className="w-full md:mr-4 pl-1 ">
                      <div className="text-xl font-semibold mb-3">Weight *</div>
                      <div className="input-border rounded-xl w-40 md:w-52">
                        <div>weight(kg)</div>
                        <input
                          required
                          min={0}
                          step="0.001"
                          onBlur={weightFieldValidation}
                          type="number"
                          name="weight"
                          value={item.itemWeight !== undefined ? item.itemWeight : (index === 0 ? productWeight : "")}
                          onInput={(e) => {
                            handleUpdateField(index, "itemWeight", e.target.value);
                            handleUpdateField(index, "deliveryPlanId", "");
                          }}
                          className="border-0 outline-none w-full text-2xl font-semibold"
                        />
                      </div>
                      {showWeightRate
                        ? (() => {
                            const kg = parseFloat(
                              item.itemWeight !== undefined && item.itemWeight !== ""
                                ? item.itemWeight
                                : index === 0
                                  ? productWeight
                                  : 0,
                            );
                            const rate = resolveWalkInWeightRate({
                              kg,
                              routeId: route,
                              weights: weightBands?.length
                                ? weightBands
                                : fruitsWeights,
                            });
                            if (rate.perKg == null) {
                              return kg > 0 ? (
                                <p className="text-xs text-stone-500 mt-2">
                                  No per kg rate for this weight and route.
                                </p>
                              ) : null;
                            }
                            return (
                              <p className="text-xs font-semibold text-stone-700 mt-2">
                                {formatCurrency(rate.perKg)}/kg
                                {rate.charge != null
                                  ? ` · ${kg}kg × rate = ${formatCurrency(rate.charge)}`
                                  : ""}
                              </p>
                            );
                          })()
                        : null}
                    </div>

                    <div className="w-full">
                      <div className="text-xl font-semibold mt-8 md:mt-0 mb-3">
                        Dimensions
                      </div>

                      <div className="flex flex-nowrap justify-start items-center gap-2 overflow-x-auto">
                        <div className="input-border rounded-xl w-20 text-sm text-center">
                          <div>Length</div>
                          <input
                            type="number"
                            step="0.01"
                            value={item.itemLength !== undefined ? item.itemLength : productLength || ""}
                            onChange={(e) =>
                              handleUpdateField(index, "itemLength", e.target.value)
                            }
                            className="text-xl font-semibold bg-white border-0 outline-none w-full text-center"
                            placeholder="0"
                          />
                        </div>

                        <div className="font-semibold text-center">X</div>

                        <div className="input-border rounded-xl w-20 text-sm text-center">
                          <div>Width</div>
                          <input
                            type="number"
                            step="0.01"
                            value={item.itemWidth !== undefined ? item.itemWidth : productWidth || ""}
                            onChange={(e) =>
                              handleUpdateField(index, "itemWidth", e.target.value)
                            }
                            className="text-xl font-semibold bg-white border-0 outline-none w-full text-center"
                            placeholder="0"
                          />
                        </div>

                        <div className="font-semibold text-center">X</div>

                        <div className="input-border rounded-xl w-20 text-sm text-center">
                          <div>Height</div>
                          <input
                            type="number"
                            step="0.01"
                            value={item.itemHeight !== undefined ? item.itemHeight : productHeight || ""}
                            onChange={(e) =>
                              handleUpdateField(index, "itemHeight", e.target.value)
                            }
                            className="text-xl font-semibold bg-white border-0 outline-none w-full text-center"
                            placeholder="0"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })()}

              {/* Add Another Item – only after last item (styled button) */}
              {index === initialObj.length - 1 && (
                <div className="radio-container mt-4 flex-col md:flex-row flex w-full sender-form-container ">
                  <div className="w-full border-0 outline-none flex justify-start items-center">
                    <button
                      type="button"
                      onClick={addAnotherItem}
                      className="self-start items-center mt-3 text-[1rem] font-semibold flex px-4 py-2 bg-gradient-to-r from-blue-500 to-purple-600 text-white rounded-lg shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300"
                    >
                      Add Another Item
                    </button>
                  </div>
                </div>
              )}

              {initialObj.length > 1 && <hr className="w-full mt-4"></hr>}
            </div>
          );
        })}

        {/* **********  ItemDetails End **************  */}


        <h1 className="mt-2 text-red-500 text-base">
          <span className="text-red-700 font-bold text-lg">Please note:</span>{" "}
          Less than 1 kg, you can use decimals (e.g, 0.5 kg)
        </h1>

        <div className=" mt-3 mb-10">

          {/* <TextArea
          
            required={true}
            variant="outlined"
            valueUpdate={(e) =>
              updateFields({ additionalInfo: e.target.value })
            }
            placeHolder={"Additional information about product"}
            alltimeValue={additionalInfo}
          /> */}
          <TextField
                            sx={textFieldStyle}
                            fullWidth
                           multiline
                            rows={4}
                            required
                            id="additionalinfo"
                            label="Additional information about product"
                            variant="outlined"
                            value={additionalInfo}
                            onChange={(e) => updateFields({  additionalInfo: e.target.value })}
                          />
           {/* <TextField
                    sx={{
                      "& .MuiInputBase-root": {
                        backgroundColor: "white",
                        border // Ensures no extra background
                      }}}
                    fullWidth
                    // multiline
                    //rows={4}
                    required
                    id="additional-information-about-product"
                    label="Additional information about product"
                    variant="outlined"
                    value={additionalInfo}
                    onChange={(e) =>updateFields({ additionalInfo: e.target.value })}
                  /> */}
          {/* <div style={{ textAlign: "center", fontFamily: "Arial, sans-serif" }}>
  <h2>Increment Number Input Box</h2>
  <input
    type="number"
    value={value}
    min="1"
    max="10"
    onChange={handleChange}
    style={{
      width: "80px",
      fontSize: "16px",
      padding: "5px",
      textAlign: "center",
      border: "1px solid #ccc",
      borderRadius: "4px",
      margin: "5px 0",
      appearance: "textfield", // Default arrow buttons
    }}
    placeholder="Enter a number"
  />
  <p style={{ fontSize: "14px", marginTop: "10px" }}>min: 1, max: 10</p>
</div> */}
        </div>
      </FormWrapper>
    </>
  );
};

export default ParcelForm;
